import DefaultLayout from '../Layouts/DefaultLayout';

import FeaturedsFirst from '../Components/FeaturedsFirst';
import FeaturedsList from '../Components/FeaturedsList';

function App() {
    return (
        <DefaultLayout>
            <div className="py-4 md:py-6 2xl:py-10">
                <div className="grid grid-cols-12 gap-4 md:mt-4 md:gap-6 2xl:gap-7.5">
                    <div className="col-span-12">
                        <h3 className="text-4xl text-secondary font-bold mb-8">Destaques da Rometal</h3>
                        <div className="mx-auto max-w-medium">
                            <FeaturedsFirst />
                        </div>
                        <FeaturedsList />
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default App;
